// features/judge-assist/parse.ts
// Pull the three fixed sections out of a Judge Assist answer.

export interface ParsedResponse {
  immediate: string | null;
  escalation: string | null;
  guidance: string | null;
  reference: string | null;
}

export function parseResponse(text: string): ParsedResponse {
  const extract = (header: string): string | null => {
    const rx = new RegExp(`\\*\\*${header}\\*\\*\\s*\\n([\\s\\S]*?)(?=\\n\\*\\*[A-Z]|$)`);
    const m = text.match(rx);
    return m ? m[1].trim() : null;
  };
  const immediate = extract('IMMEDIATE ACTION');
  // Optional: only present when the model thinks the floor judge needs help
  // (call the Head Judge and/or consult Event Management).
  const escalation = extract('ESCALATION');
  const guidance = extract('GUIDANCE');
  const reference = extract('REFERENCE');
  return {
    immediate,
    escalation,
    // If the model didn't use the headers, show the whole thing as guidance.
    guidance: guidance || (!immediate ? text : null),
    reference,
  };
}

export function extractUrls(text: string): string[] {
  const matches = text.match(/https?:\/\/[^\s)\]>"']+/g) || [];
  return Array.from(new Set(matches));
}

export function hostLabel(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url.slice(0, 28) + '…';
  }
}
